import colors from "../../utils/colors";
import DualColorCircle from "./DualColorCircle";
import { trackChatbarPersonalization } from "../../services/analytics";

const DotsTheme = ({ applyTheme, addTheme }) => {
  const handleThemeChange = (theme: string) => {
    // Apply the theme but don't track it yet - tracking will happen on "Done" click
    applyTheme(theme);
  };

  return (
    <div className="d-flex w-100 gap-2" style={{ padding: "0 0 15px 0", maxWidth: "880px" }}>
      <DualColorCircle
        color1={colors.brown}
        color2={colors.lightYellow}
        size={51}
        onClick={() => handleThemeChange("eclipse")}
        isChecked={addTheme === "eclipse"}
      />
      <DualColorCircle
        color1={colors.yellow}
        color2={colors.white}
        size={51}
        onClick={() => handleThemeChange("light")}
        isChecked={addTheme === "light"}
      />
      <DualColorCircle
        color1={colors.floralWhite}
        color2={colors.brown}
        size={51}
        onClick={() => handleThemeChange("dark")}
        isChecked={addTheme === "dark"}
      />
    </div>
  );
};

export default DotsTheme;
